export default __webpack_public_path__ + "static/media/PPI-pools-010.8fe0e542.jpg";